<style>
</style>

<template>
  <div :id="this.div_id" class="mws-upload-form">
    <form ref="fileform" :id="this.form_id">
      <p class="mws-drop-area"></p>
      <span class="drop-files" style="font-size:7px">Drop {{this.description}}</span>
      <p class="mws-upload-progress"><progress class="mws-upload-progress" max="100" :value.prop="uploadPercentage"></progress></p>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { CSRF_TOKEN } from "../common/csrf_token.js";

  export default {
    props: {
        key_field: {
            type: String,
            required: true
        },
        upload_url: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        form_id: {
            type: String,
            required: true
        },
        div_id: {
            type: String,
            required: true
        }
    },
    /*
      Variables used by the drag and drop component
    */
    data(){
      return {
        dragAndDropCapable: false,
        files: [],
        uploadPercentage: 0
      }
    },

    mounted(){
      /*
        Determine if drag and drop functionality is capable in the browser
      */
      this.dragAndDropCapable = this.determineDragAndDropCapable();
      /*
        If drag and drop capable, then we continue to bind events to our elements.
      */
      if( this.dragAndDropCapable ){
        /*
          Listen to all of the drag events and bind an event listener to each
          for the fileform.
        */
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {
          /*
            For each event add an event listener that prevents the default action
            (opening the file in the browser) and stop the propagation of the event (so
            no other elements open the file in the browser)
          */
          this.$refs.fileform.addEventListener(evt, function(e){
            e.preventDefault();
            e.stopPropagation();
          }.bind(this), false);
        }.bind(this));

        /*
          Add an event listener for drop to the form
        */
        this.$refs.fileform.addEventListener('drop', function(e){
          /*
            Capture the files from the drop event and add them to our local files
            array.
          */
          for( let i = 0; i < e.dataTransfer.files.length; i++ ){
            this.files.push( e.dataTransfer.files[i] );
          }
            /*
                Instantly upload files
            */
          this.submitFiles();
        }.bind(this));
      }
    },

    methods: {
      /*
        Determines if the drag and drop functionality is in the
        window
      */
      determineDragAndDropCapable(){
        /*
          Create a test element to see if certain events
          are present that let us do drag and drop.
        */
        var div = document.createElement('div');

        /*
          Check to see if the `draggable` event is in the element
          or the `ondragstart` and `ondrop` events are in the element. If
          they are, then we have what we need for dragging and dropping files.

          We also check to see if the window has `FormData` and `FileReader` objects
          present so we can do our AJAX uploading
        */
        var canDrag =  ( ( 'draggable' in div )
                || ( 'ondragstart' in div && 'ondrop' in div ) )
                && 'FormData' in window
                && 'FileReader' in window;
        return canDrag;
      },

      /*
        Submits the files to the server
      */
      async submitFiles(){
        /*
          Initialize the form data
        */
        let formData = new FormData();
 
        /*
          Iteate over any file sent over appending the files
          to the form data.
        */
        
        formData.append('description', this.key_field)

        for( var i = 0; i < this.files.length; i++ ){
          let file = this.files[i];

          //formData.append('document[' + i + ']', file);
          formData.append('document', file);
          break; // For our purposes we only have 1 file
        }

        /*
          Make the request to the POST /file-drag-drop-instant URL
        */
        axios.post( `${this.upload_url}${this.key_field}/`,
          formData,
          {
            headers: {
                "X-CSRFTOKEN": CSRF_TOKEN,
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: function( progressEvent ) {
              this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
            }.bind(this)
          }
        ).then(function() {
          console.log("SUCCESS!!");
		})
        .catch(function(){
          console.log("FAILURE!!");
        });
	  }
  }
};
</script>
